module.exports = __webpack_public_path__ + "static/media/error-image-placeholder.a42656bc.png";